import { useTheme } from '@mui/material';
import type { Theme } from '@mui/system';

import HomeIconFilled from './svg/homeIconFilledMono.svg';
import HomeIconOutlined from './svg/homeIconOutlineMono.svg';

export enum EHomeIconVariants {
	Primary = 'PRIMARY',
	PrimaryVariation = 'PRIMARY_VARIATION',
	Secondary = 'SECONDARY',
}

export interface IHomeIconProps {
	variant?: EHomeIconVariants;
	size?: number;
}

const getSingleColor = (variant: EHomeIconVariants, theme: Theme): string => {
	switch (variant) {
		case EHomeIconVariants.PrimaryVariation:
			return theme.palette.solutions[600];
		case EHomeIconVariants.Secondary:
			return theme.palette.neutral.main;
		case EHomeIconVariants.Primary:
		default:
			return theme.palette.primary.main;
	}
};

export const HomeIcon = ({
	variant = EHomeIconVariants.Primary,
	size = 24,
}: IHomeIconProps) => {
	const theme = useTheme();
	const color = getSingleColor(variant, theme);

	if (variant === EHomeIconVariants.Primary) {
		return (
			<HomeIconFilled
				width={size}
				height={size}
				style={{ display: 'block' }}
				fill={color}
			/>
		);
	}

	return (
		<HomeIconOutlined
			width={size}
			height={size}
			style={{ display: 'block' }}
			fill={color}
		/>
	);
};
